import React from 'react';
import { AuthenticationInformation } from '../../../interfaces/AuthenticationInformation';

export interface AuthenticationContextProps {
  authenticationInfo: AuthenticationInformation;
  saveAuthenticationInfo(values: AuthenticationInformation): void;
}

const AuthenticationContext = React.createContext<AuthenticationContextProps>(null);

export default AuthenticationContext;
